/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchProductsRequestInnerAllOfAllergensInner
 */
export interface PatchProductsRequestInnerAllOfAllergensInner {
}

/**
 * Check if a given object implements the PatchProductsRequestInnerAllOfAllergensInner interface.
 */
export function instanceOfPatchProductsRequestInnerAllOfAllergensInner(value: object): value is PatchProductsRequestInnerAllOfAllergensInner {
    return true;
}

export function PatchProductsRequestInnerAllOfAllergensInnerFromJSON(json: any): PatchProductsRequestInnerAllOfAllergensInner {
    return PatchProductsRequestInnerAllOfAllergensInnerFromJSONTyped(json, false);
}

export function PatchProductsRequestInnerAllOfAllergensInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchProductsRequestInnerAllOfAllergensInner {
    return json;
}

export function PatchProductsRequestInnerAllOfAllergensInnerToJSON(json: any): PatchProductsRequestInnerAllOfAllergensInner {
    return PatchProductsRequestInnerAllOfAllergensInnerToJSONTyped(json, false);
}

export function PatchProductsRequestInnerAllOfAllergensInnerToJSONTyped(value?: PatchProductsRequestInnerAllOfAllergensInner | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

